import React from 'react'
import { colorsPN } from '@news-mono/design-tokens'

export const IconNow: React.FC<{ color?: string }> = ({
    color = colorsPN.icon.brand,
}) => (
    <svg
        viewBox="184.73 0 177.23 63.71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M184.727 18.7809V44.9258C184.727 55.2992 193.141 63.7076 203.512 63.7076H343.172C353.544 63.7076 361.954 55.2992 361.954 44.9258V18.7809C361.954 8.41105 353.544 0 343.172 0H203.512C193.141 0 184.727 8.41105 184.727 18.7809Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M284.627 12.1776H295.252L303.754 39.6378H303.917L311.845 12.1776H322.47L330.968 39.6378H331.132L339.306 12.1776H349.193L335.874 51.4077H326.147L316.829 24.6007H316.667L308.413 51.4077H298.277L284.627 12.1776Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M264.639 43.6703C271.832 43.6703 276.163 38.0335 276.163 31.903C276.163 25.7734 271.832 20.134 264.639 20.134C257.447 20.134 253.116 25.7734 253.116 31.903C253.116 38.0335 257.447 43.6703 264.639 43.6703ZM264.639 11.3077C276.491 11.3077 285.971 19.5619 285.971 31.9031C285.971 44.2425 276.491 52.5003 264.639 52.5003C252.788 52.5003 243.308 44.2425 243.308 31.9031C243.308 19.5619 252.788 11.3077 264.639 11.3077Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M203.294 12.2889H212.612V18.5816H212.776C214.573 14.6594 218.251 11.3077 224.79 11.3077C235.333 11.3077 239.093 18.7456 239.093 26.7538V51.5191H229.286V31.6589C229.286 27.3259 228.959 20.134 222.093 20.134C215.637 20.134 213.102 24.8752 213.102 30.1056V51.5191H203.294V12.2889Z"
            fill="white"
        />
    </svg>
)
